import { createContext } from 'react'
import { fixedRedirects, fixedRedirects2 } from '~/utils'
import type { NonceType } from '~/types'

// Nonce value for scripts (CSP headers)
export const NonceContext = createContext<NonceType>(undefined) // used for content security policy

// Function that checks if we should redirect a specific route
interface RedirectProps {
  pathname: string
  searchQuery?: string
  redirects?: { type: string; oldSlug: string; newSlug: string }[]
}

export const checkRedirects = ({
  pathname,
  searchQuery,
  redirects,
}: RedirectProps) => {
  // Check if we have any fixed redirects locally
  const allFixedRedirects = [...fixedRedirects, ...fixedRedirects2]
  const fixedRedirectMatch = allFixedRedirects?.find(e => e.oldSlug == pathname)

  // Check if CMS has any specific redirects
  const redirectMatch = redirects?.find(e => e.oldSlug == pathname)

  if (fixedRedirectMatch) {
    // Use our fixed redirect
    return { code: '301', slug: fixedRedirectMatch.newSlug }
  } else if (redirectMatch) {
    // Use our CMS redirect
    return { code: redirectMatch.type, slug: redirectMatch.newSlug }
  } else if (pathname.endsWith('/') && pathname !== '/') {
    // Don't allow trailing slash URLs, preserving any search queries
    return { code: '301', slug: `${pathname.slice(0, -1)}${searchQuery}` }
  }

  return null
}

type DebugFn = (...args: Parameters<typeof console.log>) => void

export const loadDebug = (enabledRef: { current: boolean }): DebugFn => {
  return (...args) => {
    if (enabledRef.current) {
      console.log(...args)
    }
  }
}
